
import Benefactor from "@/models/Sobrevivencia/Benefactor";
import { Component, Prop, Vue,Watch } from "vue-property-decorator";
import SquareShadowBox from "@/components/SquareShadowBox.vue";
import { translatedStates } from "@/enums/PossibleStates";
import { BIconDownload } from "bootstrap-vue";
import { formatFechaAfpSiembra } from "@/utils/HelperFunctions";
import { formatCedula } from "@/utils/HelperFunctions";
import AfiliadoService from "@/services/AfiliadoService";
import TipoBeneficioEnum from "@/enums/TipoBeneficioEnum";
import ParamsGetSolicitud from "@/models/ParamsGetSolicitud";
import SolicitudBeneficio from "@/models/SolicitudBeneficio";
import ParametrosObtencionPresolicitud from "@/models/ParametrosObtencionPresolicitud";
import ServiceResponseSolicitudes from "@/services/response-models/ServiceResponseSolicitudes";
import SobrevivenciaService from "@/services/SobrevivenciaService";
import VueHtml2pdf from "vue-html2pdf";

import BaseSobrevivenciaRequest from "@/models/Sobrevivencia/BaseSobrevivenciaRequest";
import BenefactorsRequiredDocuments from "./BenefactorsRequiredDocuments.vue";
 

import Swal from "sweetalert2";

import { AxiosResponse } from "axios";
import Presolicitud from "@/models/Presolicitud";
import BenefactorDocument from "@/models/Sobrevivencia/BenefactorDocument";

import { Action, Getter } from "vuex-class";
import NoLoggedUser from "@/models/Sobrevivencia/NoLoggedUser/NoLoggedUser";
import User from "@/models/User";
import ReenvioBiometricaRequest from "@/models/Sobrevivencia/Biometric/ReenvioValidacionBiometricaRequest";
import DistribucionBalance from "@/models/Sobrevivencia/DistribucionBalante/DistribucionBalance";
@Component({ components: { SquareShadowBox, BIconDownload,VueHtml2pdf,BenefactorsRequiredDocuments } })
export default class Resumen extends Vue {
  @Getter ("currentBenefactor") currentBenefactor : Benefactor;
  @Getter("noLoggedUser") noLoggedUser: NoLoggedUser;
  @Getter("user") user: User;
  
  items: DistribucionBalance[] = [];
  public loadingPage:boolean=false;
  public afiliadoService: AfiliadoService = new AfiliadoService();
   public currentSolicitud: SolicitudBeneficio = null;
   public benefactors: Benefactor[]=[];
     public currentPresolicitud: Presolicitud = null;
      public sobrevivenciaService: SobrevivenciaService = new SobrevivenciaService();
        public generalDocs: BenefactorDocument[] = [];
  public loading: boolean = false;
  public storageSASToken :string="";
  public cartaAseguradoraUrl:string="";
  public declaracionDocUrl:string="";
  public numeroSolicitud: number = null;
  public states = translatedStates;

  public thStyle = {
    "background-color": "#ed8b2f",
    color: " #fff",
    "text-align": "center",
  };
  public fields = [
    {
      key: "benefactor",
      label: "Beneficiario",
      thStyle: this.thStyle,
      tdClass: "table_data",
    },
    {
      key: "tutor",
      label: "Tutor",
      thStyle: this.thStyle,
      tdClass: "table_data",
    },
    {
      key: "monto",
      label: "Monto",
      thStyle: this.thStyle,
      tdClass: "table_data",
    },
    {
      key: "contact",
      label: "Contacto",
      thStyle: this.thStyle,
      tdClass: "table_data",
    }, 
    {
      key: "actions",
      label: "Validación biométrica, elección método de pago y firma descargo",
      thStyle: this.thStyle,
      tdClass: "table_data",
    },
  ];


  async mounted()
  {
    this.loadingPage = true;
    if (this.$route.query.numeroSolicitud || this.numeroSolicitud != null) {
       if(this.numeroSolicitud == null){
        this.numeroSolicitud = Number(this.$route.query.numeroSolicitud);
       }
    }
     this.handleEncrytNumSolicitud();
    if(this.numeroSolicitud!= null ){
    this.afiliadoService
        .getPresolicitud(
          new ParametrosObtencionPresolicitud(this.numeroSolicitud, null, null,  )
        )
        .then((response: AxiosResponse<ServiceResponseSolicitudes>) => {
          if (
            response.data.solicitudes &&
            response.data.solicitudes.length > 0
          ) {
            // The first one must be the record we are looking for
            this.currentPresolicitud = response.data.solicitudes[0];

            //Send to encuesta
            if (!this.currentPresolicitud.encuestaCompletada) {
              //The encuesta page needs to load from scratch so dont use vue router.
              // this.$router.push({
              //     path: "/encuesta",
              //     query: {
              //             tipoBeneficio: this.currentPresolicitud.tipoBeneficio,
              //             numeroSolicitud: this.currentPresolicitud.numeroSolicitud+"",
              //             redirectTo: this.$route.fullPath
              //         }
              // });
              // window.location.href = `encuesta?tipoBeneficio=${this.currentPresolicitud.tipoBeneficio}&numeroSolicitud=${this.currentPresolicitud.numeroSolicitud}&redirectTo=${this.$route.fullPath}`;
              return;
            }

            let promise1 = this.getDatosSolicitud(
              this.currentPresolicitud.numeroSolicitud
            );
             
            Promise.all([promise1  ]).finally(() => {
              Swal.close();
            });
          }
        })
        .catch(() => {
          Swal.close();
        })
        .finally(() => {
          this.loading = false;
        });

      this.getStorageSasToken();
      this.getDeclaracionBeneficiariosLink();
    await this.getDatosSolicitud(this.numeroSolicitud);
    await this.getBeneficiarios();
    await this.getDocumentosGenerales()
    this.loadingPage=false;
    await this.getDocumentosBeneficiarios();
    this.getData();
    this.getCartaAseguradoraUrl();
    
    }
  }  
  public getDatosSolicitud(numeroSolicitud: number) {
    let promise = this.afiliadoService.getSolicitud(
      new ParamsGetSolicitud(TipoBeneficioEnum.Fallecimiento, numeroSolicitud)
    );
    promise.then((response) => {
      if (response.data.respCode == 200) {
        this.currentSolicitud = response.data.entity;
      }
    });

    return promise;
  }

    public formatDate(dateString: string) {
    return formatFechaAfpSiembra(dateString);
  }
   

  public formatearCedula(value : string){
    return formatCedula(value)
  }
  async getBeneficiarios() {
    const response = await this.sobrevivenciaService.GetBeneficiarios(
      "PortalBe",
      "0092873730",
      this.numeroSolicitud
    );

    this.benefactors = response.data.data;
  }
  async getDocumentosGenerales() {
    const response = await this.sobrevivenciaService.GetDocumentosBeneficiarios(
      this.numeroSolicitud,
      "PortalBe",
      "0092873730"
    );

    this.generalDocs = response.data.data;
  }
  generateReport() {
    (this.$refs.html2Pdf as any).generatePdf();
  }

  async getDocumentosBeneficiarios() {
    const promises = this.benefactors.map(async (benefactor) => {
      const response = await this.sobrevivenciaService.GetDocumentosBeneficiarios(
        this.numeroSolicitud,
        "PortalBe",
        "0092873730",
        benefactor.idBeneficiario
      );

      response.data.data = response.data.data.map((document) => {
        document.codigoRuta = `${benefactor.numIdBeneficiario}/${document.codTipDocumento}`;

        return document;
      });

      benefactor.documents = response.data.data;

      return benefactor;
    });

    this.benefactors = await Promise.all(promises);
  }

   public getCartaAseguradoraUrl(){
    const found = this.generalDocs.filter((x)=>Number(x.codTipDocumento) == 209)
     if(found && found.length>0){
      this.cartaAseguradoraUrl= found[0].link;
     }else{return ""}
  }
  public async getStorageSasToken(){
    this.sobrevivenciaService.getStorageSAS().then((resp)=>{ 
      this.storageSASToken = resp.data;
    })
  }
   get aseguradoraDownloadLink(){
    if(this.cartaAseguradoraUrl?.length > 0 && this.storageSASToken?.length > 0 ) {
      return `${this.cartaAseguradoraUrl}${this.storageSASToken}&xyz=PT24H`
    }
    return ""
  }

  public handleNoLoggedUser() {
   try{
     if(this.$route.query.params){
      let params = this.$route.query.params.toString();
      params = params.replace(/\s/g, '+') 
      let decypt =  this.afiliadoService.decryptByDES(params); 
      
      let noLoggedUser : NoLoggedUser = JSON.parse(decypt);
       this.user.cedula = noLoggedUser.benefPrincipal;
       this.numeroSolicitud = noLoggedUser.numPreSolicitud;
       this.$store.dispatch(
              "setNoLoggedUser",
              noLoggedUser
            );
       
    }

   }catch(e){
      console.log("error " ,e)
   }
 
  }
  public handleEncrytNumSolicitud() {
   try{
     if(this.$route.query.params){
      let params = this.$route.query.params.toString();
      params = params.replace(/\s/g, '+') 
      let decypt =  this.afiliadoService.decryptByDES(params); 
      
      let noLoggedUser : NoLoggedUser = JSON.parse(decypt); 
       this.numeroSolicitud = noLoggedUser.numPreSolicitud; 
    }

   }catch(e){

      console.log("error " ,e)
      this.$router.push("/solicitudes-beneficiario")
   }
 
  }

  public async renviarValidacionBiometrica(benefactor:Benefactor){
    this.showLoadingAlert()
    let numId : string = "";
     if(benefactor.cedResponsable != null && benefactor.cedResponsable.length>0){
      numId = benefactor.cedResponsable
     }else{
      numId= benefactor.numIdBeneficiario
     }
    let request : ReenvioBiometricaRequest = new ReenvioBiometricaRequest(numId,this.currentPresolicitud.numeroSolicitud,numId)
    await this.sobrevivenciaService.reenviarValidacionBiometrica(request).then((resp)=>{
      if(resp.data.code == 200){
        Swal.close();
        this.showSuccessAlert("El correo/SMS ha sido enviado correctamente.");
      }else{
        this.showErrorAlert()

      }
    });
    
  }

  @Watch("benefactors",{immediate:true})
  public benefactorsChanged(newValue, oldValue) {   
    let benefactor: Benefactor;
    if(this.noLoggedUser !=null && this.noLoggedUser.beneficiario != null){
      if (this.benefactors) {
       benefactor = this.benefactors.find(
        (benefactor) => benefactor.idBeneficiario == this.noLoggedUser.beneficiario
      );
      benefactor.cedulaBenefPrincipal = this.noLoggedUser.benefPrincipal;
    }   
    }else{ 
      if (this.benefactors && this.benefactors.length>0) {
       benefactor = this.benefactors.find(
        (benefactor) => benefactor.esBenefPrincipal == "S"
      );
      benefactor.esBenefPrincipal = "S";
      benefactor.cedulaBenefPrincipal = benefactor.numIdBeneficiario;
    }}


      // console.log("current benefactor",benefactor)
     this.$store.dispatch(
              "setCurrentBenefactor",
              benefactor
            );
  }

   public showLoadingAlert(message: string = "Valoramos tu tiempo. Este proceso puede tomar unos minutos. Gracias por utilizar nuestra plataforma digital de beneficios."): void {
    Swal.fire({
      text: message,
      icon: "info",
      timerProgressBar: true,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false,
    });
  }
  public showErrorAlert(
    message: string="Ha ocurrido un error en la comunicación.Por favor intentar más tarde.",
    allowOutsideClick: boolean = true
  ): void {
    Swal.fire({
      text: message,
      icon: "error",
      showConfirmButton: allowOutsideClick,
      confirmButtonText: "Ok",
      allowOutsideClick,
    });
  }
  public showSuccessAlert(message: string = "") {
    Swal.fire({
      html: message.length > 0 ? message : "",
      showConfirmButton: false,
      icon: "success",
      timer: 3000,
    });
  }

  public async getDeclaracionBeneficiariosLink(){
    this.sobrevivenciaService.getDeclaracionBeneficiariosDoc(this.numeroSolicitud).then(result =>{
      this.declaracionDocUrl = result.data
    }).catch(error =>{
      console.log(error )
    })
  }

    async getData() {
    try {
      let request = new BaseSobrevivenciaRequest(
        "PortalBe",
        "00000000000",
        this.numeroSolicitud
      );
      let responseBalance =
        await this.sobrevivenciaService.getDistribucionBalance(request);
      // this.items = [...responseBalance.data.data.filter(x=> x.porcentaje!= null && x.porcentaje!= 0 )]; 
      this.items =responseBalance.data.data; 
      this.items.forEach((balance) => {
         
        this.benefactors.forEach((benefactor,index) => {
          
          if (balance.idBeneficiario == benefactor.idBeneficiario) {
              balance.nombreBeneficiario =benefactor.primerNombre + " " + benefactor.primerApellido;
              balance.montoPensionFormat = "RD$ "+ this.numberWithCommas(balance.montoPension.toFixed(2))
              balance.porcentajeFormat = balance.porcentaje + "%";
              if(balance.porcentaje == null || balance.porcentaje == 0){ 
                this.benefactors=  this.benefactors.filter((x)=>{
                  if(x.idBeneficiario != benefactor.idBeneficiario){
                    return x
                  }
                })
              }
          }
        });
      });
    } catch (error) {}
  }
  public numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  public getMontoForTable(idBeneficiario){

    if(this.items.length>0 && this.benefactors.length >0){
      let montoFormat:string="";
      let distribucion:DistribucionBalance =  this.items.find( item => item.idBeneficiario == idBeneficiario);
      if(distribucion!=null){
        montoFormat = `${distribucion.montoPensionFormat} (${distribucion.porcentaje}%)`
        return montoFormat;
     }
    }
    return ""
  }

  public goHome(){
    this.$router.push("/home")
  }

  
}


